module.exports = __webpack_public_path__ + "img/ss3.0f00515b.jpg";